import { errorMessage } from "actions/message";
import { post, get } from "utils/api";
import { browserHistory } from "browser-history";

export const Types = {
  // Dashboard
  CALL_QUALITY_DASHBOARD_REQUEST: "CALL_QUALITY_DASHBOARD_REQUEST",
  CALL_QUALITY_DASHBOARD_SUCCESS: "CALL_QUALITY_DASHBOARD_SUCCESS",
  CALL_QUALITY_DASHBOARD_FAILURE: "CALL_QUALITY_DASHBOARD_FAILURE",
  // Individual Calls
  CALL_QUALITY_CALLS_REQUEST: "CALL_QUALITY_CALLS_REQUEST",
  CALL_QUALITY_CALLS_SUCCESS: "CALL_QUALITY_CALLS_SUCCESS",
  CALL_QUALITY_CALLS_FAILURE: "CALL_QUALITY_CALLS_FAILURE",
  // By Coach
  CALL_QUALITY_BY_COACH_REQUEST: "CALL_QUALITY_BY_COACH_REQUEST",
  CALL_QUALITY_BY_COACH_SUCCESS: "CALL_QUALITY_BY_COACH_SUCCESS",
  CALL_QUALITY_BY_COACH_FAILURE: "CALL_QUALITY_BY_COACH_FAILURE",
  // By Company
  CALL_QUALITY_BY_COMPANY_REQUEST: "CALL_QUALITY_BY_COMPANY_REQUEST",
  CALL_QUALITY_BY_COMPANY_SUCCESS: "CALL_QUALITY_BY_COMPANY_SUCCESS",
  CALL_QUALITY_BY_COMPANY_FAILURE: "CALL_QUALITY_BY_COMPANY_FAILURE",
  // By Team
  CALL_QUALITY_BY_TEAM_REQUEST: "CALL_QUALITY_BY_TEAM_REQUEST",
  CALL_QUALITY_BY_TEAM_SUCCESS: "CALL_QUALITY_BY_TEAM_SUCCESS",
  CALL_QUALITY_BY_TEAM_FAILURE: "CALL_QUALITY_BY_TEAM_FAILURE",
  // Filter Options
  CALL_QUALITY_FILTER_OPTIONS_REQUEST: "CALL_QUALITY_FILTER_OPTIONS_REQUEST",
  CALL_QUALITY_FILTER_OPTIONS_SUCCESS: "CALL_QUALITY_FILTER_OPTIONS_SUCCESS",
  CALL_QUALITY_FILTER_OPTIONS_FAILURE: "CALL_QUALITY_FILTER_OPTIONS_FAILURE"
};

/**
 * Fetches dashboard summary with KPIs and chart data
 */
export const fetchCallQualityDashboard = (params) => async dispatch => {
  dispatch({ type: Types.CALL_QUALITY_DASHBOARD_REQUEST });
  try {
    const response = await post("call-quality/dashboard", params);
    dispatch({ type: Types.CALL_QUALITY_DASHBOARD_SUCCESS, payload: response });
    return response;
  } catch (error) {
    dispatch({ type: Types.CALL_QUALITY_DASHBOARD_FAILURE });
    dispatch(errorMessage("Failed to fetch call quality dashboard"));
  }
};

/**
 * Fetches paginated list of individual call quality records
 */
export const fetchCallQualityCalls = (params) => async dispatch => {
  dispatch({ type: Types.CALL_QUALITY_CALLS_REQUEST });
  try {
    const response = await post("call-quality/calls", params);
    dispatch({ type: Types.CALL_QUALITY_CALLS_SUCCESS, payload: response });
    return response;
  } catch (error) {
    dispatch({ type: Types.CALL_QUALITY_CALLS_FAILURE });
    dispatch(errorMessage("Failed to fetch call quality data"));
  }
};

/**
 * Fetches call quality metrics aggregated by coach
 */
export const fetchCallQualityByCoach = (params) => async dispatch => {
  dispatch({ type: Types.CALL_QUALITY_BY_COACH_REQUEST });
  try {
    const response = await post("call-quality/by-coach", params);
    dispatch({ type: Types.CALL_QUALITY_BY_COACH_SUCCESS, payload: response });
    return response;
  } catch (error) {
    dispatch({ type: Types.CALL_QUALITY_BY_COACH_FAILURE });
    dispatch(errorMessage("Failed to fetch coach quality metrics"));
  }
};

/**
 * Fetches call quality metrics aggregated by company
 */
export const fetchCallQualityByCompany = (params) => async dispatch => {
  dispatch({ type: Types.CALL_QUALITY_BY_COMPANY_REQUEST });
  try {
    const response = await post("call-quality/by-company", params);
    dispatch({ type: Types.CALL_QUALITY_BY_COMPANY_SUCCESS, payload: response });
    return response;
  } catch (error) {
    dispatch({ type: Types.CALL_QUALITY_BY_COMPANY_FAILURE });
    dispatch(errorMessage("Failed to fetch company quality metrics"));
  }
};

/**
 * Fetches call quality metrics aggregated by team
 */
export const fetchCallQualityByTeam = (params) => async dispatch => {
  dispatch({ type: Types.CALL_QUALITY_BY_TEAM_REQUEST });
  try {
    const response = await post("call-quality/by-team", params);
    dispatch({ type: Types.CALL_QUALITY_BY_TEAM_SUCCESS, payload: response });
    return response;
  } catch (error) {
    dispatch({ type: Types.CALL_QUALITY_BY_TEAM_FAILURE });
    dispatch(errorMessage("Failed to fetch team quality metrics"));
  }
};

/**
 * Fetches filter options for dropdowns (companies, teams, coaches, dispositions)
 */
export const fetchCallQualityFilterOptions = () => async dispatch => {
  dispatch({ type: Types.CALL_QUALITY_FILTER_OPTIONS_REQUEST });
  try {
    const response = await get("call-quality/filter-options");
    dispatch({ type: Types.CALL_QUALITY_FILTER_OPTIONS_SUCCESS, payload: response });
    return response;
  } catch (error) {
    dispatch({ type: Types.CALL_QUALITY_FILTER_OPTIONS_FAILURE });
    dispatch(errorMessage("Failed to fetch filter options"));
  }
};

/**
 * Exports call quality data to CSV
 */
export const exportCallQuality = (params) => async dispatch => {
  try {
    await post("call-quality/export", params);
    browserHistory.push("/exports");
  } catch (error) {
    dispatch(errorMessage("Failed to export call quality data"));
  }
};
